import { MAT_DIALOG_DATA, MatSelect } from "@angular/material";
import { SoundEnum } from "src/app/enums/sound.enum";
import { TranslateService } from "@ngstack/translate";
import { MatDialogRef } from "@angular/material/dialog";
import { Component, OnInit, Inject } from "@angular/core";
import { ILevelInfo } from "./../../../../../interfaces/levelInfo";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { ErrorsService } from "src/app/services/common/errors.service";
import { ILevelPrerequisite } from "src/app/interfaces/level-prequisite";
import { SnackBarService } from "src/app/services/common/snackBar.service";
import { ILevelRelationType } from "src/app/interfaces/levelInfoRelationType";
import { StaticValueService } from "src/app/services/http/business/staticValue/static-value.service";
import { LevelInfoPrerequisiteService } from "./../../../../../services/http/business/levelInfo-prerequisite/level-info-prerequisite.service";
import { IEducationPackage } from "src/app/interfaces/educationPackage";
import { LevelInfoService } from "src/app/services/http/business/levelInfo/level-info.service";
import { EducationPackageService } from "src/app/services/http/business/educationPackage/education-package.service";
import { IError } from "src/app/interfaces/error.interface";

@Component({
  selector: "app-level-prerequisite-entry",
  templateUrl: "./level-prerequisite-entry.component.html",
  styleUrls: ["./level-prerequisite-entry.component.css"]
})
export class LevelPrerequisiteEntryComponent implements OnInit {
  param: any;
  errorList: IError[] = [];
  leveId: any;
  errObject: any;
  form: FormGroup;
  packageId: number;
  errors = new Array();
  levelList: ILevelInfo[];
  packageList: IEducationPackage[];
  relationTypeList: ILevelRelationType[];

  constructor(
    private fb: FormBuilder,
    private snackbar: SnackBarService,
    public translate: TranslateService,
    private errorService: ErrorsService,
    private levelService: LevelInfoService,
    private staticValuService: StaticValueService,
    private eduPackageService: EducationPackageService,
    private dialogRef: MatDialogRef<LevelPrerequisiteEntryComponent>,
    private levelInfoPrerequisiteService: LevelInfoPrerequisiteService,

    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.packageId = parseInt(data.packageId);
    this.leveId = parseInt(data.bid);
  }

  ngOnInit() {
    if (this.data && this.data.packageId) {
      let packageId: number;
      this.levelService.getById(this.data.LevelId).subscribe(res => {
        packageId = res.PackageId;
        this.levelService
          .getlistByEducationPackageId(packageId)
          .subscribe(res => {
            this.form.controls.packageId.setValue(packageId);
            this.levelList = res;
          });
      });
    }
    this.createForm();
    this.loadPackageList();
    this.getRelationType();
  }

  createForm() {
    this.form = this.fb.group({
      Id: [this.data && this.data.Id ? this.data.Id : 0],
      packageId: [null, Validators.required],
      BaseLevelId: [this.data.bid],
      LevelId: [
        this.data && this.data.LevelId ? this.data.LevelId.toString() : null,
        Validators.compose([Validators.required])
      ],
      RelationTypeId: [
        this.data && this.data.RelationType
          ? this.data.RelationType.toString()
          : null,
        Validators.compose([Validators.required])
      ]
    });
  }

  loadPackageList() {
    this.eduPackageService.getList(0, 0).subscribe(res => {
      this.packageList = res.DataList;
    });
  }

  loadLevels(e: MatSelect) {
    this.levelService.getlistByEducationPackageId(e.value).subscribe(res => {
      this.levelList = res;
    });
  }

  getRelationType() {
    this.staticValuService.getRelationType(0, 0).subscribe(res => {
      this.relationTypeList = res;
    });
  }

  submit(data: ILevelPrerequisite) {
    if (this.data && this.data.Id) {
      this.levelInfoPrerequisiteService.edit(data).subscribe(
        () => {
          this.onClose();
          this.snackbar.OpenSnackBar(
            this.translate.get("success.registration"),
            "ok",
            5000,
            SoundEnum.beep
          );
        },
        err => {
          // this.errObject = this.errorService.getError(err);
          // this.param = this.errorService.objectError(this.errObject);
          // this.errors = this.errorService.returnError(err);
          this.errorList = this.errorService.getErrorList(err.error);
        }
      );
    } else {
      this.levelInfoPrerequisiteService.add(data).subscribe(
       () => {
          this.onClose();
          this.snackbar.OpenSnackBar(
            this.translate.get("success.registration"),
            "ok",
            5000,
            SoundEnum.beep
          );
        },
        err => {
          // this.errObject = this.errorService.getError(err);
          // this.param = this.errorService.objectError(this.errObject);
          // this.errors = this.errorService.returnError(err);
          this.errorList = this.errorService.getErrorList(err.error);
        }
      );
    }
  }

  onClose() {
    this.dialogRef.close();
  }
}
